import React from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import DetailItem from './DetailItem'
import { downloadDocument, forceDownload } from '../../api'

import styles from './detail.module.css'

function PurchasedExtraItems({
  selectedInfo,
  updateHandler,
  userId,
  invoiceReady,
  hasParent,
}) {
  return (
    <>
      <DetailItem
        value={selectedInfo.cutDown}
        label="Cut Down"
        updateHandler={(cutDown) => updateHandler({ cutDown })}
        editable
      />
      <DetailItem
        value={selectedInfo.useLength}
        label="Use Length"
        updateHandler={(useLength) => updateHandler({ useLength })}
        editable
      />
      <DetailItem
        value={selectedInfo.address}
        label="Address"
        updateHandler={(address) => updateHandler({ address })}
        editable
      />
      <DetailItem
        className={styles.fullWidth}
        value={selectedInfo.syncId}
        label="Request Streaming Sync ID*"
        placeholder="Campaign online video URL link to whitelist."
        updateHandler={(syncId) => updateHandler({ syncId })}
        editable
        title={
          selectedInfo.syncIdVerified
            ? 'Link was sent for streaming approval. This may take a few hours to validate from the streaming provider system.'
            : 'Please save your streaming link to whitelist an online campaign with your license rights.'
        }
      />

      <div className={styles.hr} />

      {hasParent && (
        <p className={cn(styles.mainText, styles.fullWidth)}>
          <Link
            className={styles.itemButton}
            to={`/profile/${selectedInfo.refRequestType}/${selectedInfo.refRequestId}`}
          >
            <strong style={{ textTransform: 'uppercase' }}>
              View Source {selectedInfo.refRequestType}
            </strong>
          </Link>
        </p>
      )}
      <p className={cn(styles.mainText, styles.fullWidth)}>
        <button
          onClick={() =>
            downloadDocument({
              userId,
              id: selectedInfo.id,
              kind: 'invoice',
            })
          }
          disabled={!invoiceReady}
          className={styles.itemButton}
        >
          <strong style={{ textTransform: 'uppercase' }}>
            Download Invoice
          </strong>
        </button>{' '}
        {!invoiceReady && (
          <Link to="/profile/billing-information" className={styles.itemButton}>
            <strong style={{ textTransform: 'uppercase' }}>
              Complete Billing Info first
            </strong>
          </Link>
        )}
      </p>
      <p className={cn(styles.mainText, styles.fullWidth)}>
        <button
          className={styles.itemButton}
          onClick={() =>
            downloadDocument({
              userId,
              id: selectedInfo.id,
            })
          }
        >
          <strong style={{ textTransform: 'uppercase' }}>
            Download Master & Publishing Rights License
          </strong>
        </button>
      </p>
      <p className={cn(styles.mainText, styles.fullWidth)}>
        <a
          className={cn(styles.itemButton, {
            [styles.disabled]: !selectedInfo.file,
          })}
          href={selectedInfo.file}
        >
          Download High Quality Audio
        </a>{' '}
        {!selectedInfo.file && (
          <span className={styles.advice}>
            Processing purchase. Available soon.
          </span>
        )}
      </p>
      <p className={styles.mainText}>
        <button
          className={cn(styles.itemButton, {
            [styles.disabled]: !selectedInfo.trackSlug,
          })}
          onClick={() => {
            forceDownload(
              `${process.env.REACT_APP_TRACK_URI}/${selectedInfo.trackSlug}.mp3`,
              `${selectedInfo.trackArtist}_${selectedInfo.trackName}_preview.mp3`
            )
          }}
        >
          Download MP3 Preview
        </button>
      </p>
    </>
  )
}

export default PurchasedExtraItems
